const ADMIN_PERMISSION_LABELS: Record<string, string> = {
  "admin.v2.access": "Admin portal access",
  "analytics.view": "Analytics access",
  "approvals.view": "Approvals access",
  "audit.view": "Audit log access",
  "automation.view": "Automation access",
  "billing.view": "Billing access",
  "crm.edit": "CRM editing access",
  "crm.view": "CRM access",
  "entitlements.manage": "Entitlements management access",
  "exports.run": "Export access",
  "featureflags.manage": "Feature flag management access",
  "forms.manage": "Forms management access",
  "integrations.view": "Integration access",
  "jobs.view": "Jobs access",
  "kb.manage": "Knowledge base management access",
  "learning.view": "Learning access",
  "messaging.manage_identities":
    "Email & Comms sender identity management access",
  "messaging.view": "Email & Comms access",
  "organisations.access_all": "Organisation access",
  "rbac.manage": "Team permissions management access",
  "segments.manage": "Audiences management access",
  "support.manage": "Support management access",
  "support.spoof_user": "Support spoofing access",
  "support.view": "Support access",
  "tags.manage": "Audiences tag governance access",
};

const PERMISSION_KEY_PATTERN = /\b[a-z0-9]+(?:\.[a-z0-9_]+)+\b/gi;

export const UNKNOWN_ADMIN_PERMISSION_LABEL = "Additional admin access";

export const formatAdminPermissionLabel = (permissionKey: string): string =>
  ADMIN_PERMISSION_LABELS[permissionKey] ?? UNKNOWN_ADMIN_PERMISSION_LABEL;

export const sanitizeAdminPermissionCopy = (copy: string): string =>
  copy.replace(PERMISSION_KEY_PATTERN, (matchedPermission) =>
    formatAdminPermissionLabel(matchedPermission.toLowerCase()),
  );
